// B863: where the console links to the docs. `bun run build` writes the docs into
// dist/docs with the base /ui/docs/ (package.json `docs:console`), and a node serves
// /ui/<rel> from its webroot (web/dist). B1233: the link names the docs DIRECTORY; a
// node serves `<dir>/index.html` for `/ui/<dir>/` (B1229).
// web/scripts/docs-console.test.js keeps this and the build script in step.
export const DOCS_HREF = '/ui/docs/';
